import React, { FC } from "react"
import { Tooltip } from "react-tooltip"

import { Icon, ICON_TYPES } from "@helpscout/hs-marketing-shared-components"

type QuestionCardActionButtonProps = {
  className?: string,
  iconType: keyof typeof ICON_TYPES,
  id: string,
  isMobile?: boolean,
  onClick?: () => void,
  onMouseDown?: (e: React.MouseEvent<HTMLButtonElement> | React.TouchEvent<HTMLButtonElement>) => void,
  tooltipText?: string,
  tooltipOnRight?: boolean,
}

const QuestionCardActionButton: FC<QuestionCardActionButtonProps> = ({
  className,
  iconType,
  id,
  isMobile,
  onClick,
  onMouseDown,
  tooltipText,
  tooltipOnRight,
}) => {
  return (
    <button
      className={`QuestionCardActionButton ${className ? className : ""}`}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onTouchStart={onMouseDown}
      data-tooltip-id={`Tooltip--${id}`}
    >
      <Icon
        size="16px"
        type={iconType as ICON_TYPES}
      />
      {tooltipText && (
        <Tooltip
          delayShow={500}
          id={`Tooltip--${id}`}
          style={{ maxWidth: "300px" }}
        >
          {tooltipText}
        </Tooltip>
      )}
    </button>
  )
}

export default QuestionCardActionButton
